import {FolderSection, NumberIDFolder, StringIDFolder} from 'constants/FolderConstants';
import normalizeFolder from 'folders/util/normalizeFolder';
import {getStore} from 'redux-stores/Store';

import * as SidepanelReduxActions from './SidepanelReduxActions';

export default function listFolderSection(
  folder: NumberIDFolder | StringIDFolder,
  section: FolderSection
): void {
  const normalizedFolder = normalizeFolder(folder);
  getStore().dispatch(SidepanelReduxActions.listFolderSection(normalizedFolder, section));
}
